<script setup>
import { ref, onMounted, defineEmits } from "vue";
import { useStore } from "vuex";
import { useCookies } from "vue3-cookies";
import axios from "axios";
import { MaskInput } from "vue-3-mask";

import validatePass from "@/directives/validatePass.js";
import validatePhone from "@/directives/validatePhone.js";

const { cookies: Cookies } = useCookies();

const store = useStore();

const emit = defineEmits(["goAccount"]);

const apiUrl = ref(store.getters.getApiUrl);

const etap = ref(1);
const role = ref(null);

const inputUsername = ref("");
const inputPassword = ref("");

const defaultFlag = ref({
  icon: require("@/assets/image/icons/RU.svg"),
  name: "RU",
  mask: "+7(###) ###-##-##",
  regex: /^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/,
});

const allFlags = [
  {
    icon: require("@/assets/image/icons/RU.svg"),
    name: "RU",
    mask: "+7(###) ###-##-##",
    regex: /^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/,
  },
  {
    icon: require("@/assets/image/icons/BY.svg"),
    name: "BY",
    mask: "+375(##) ###-##-##",
    regex: /^\+375\(\d{2}\) \d{3}-\d{2}-\d{2}$/,
  },
  {
    icon: require("@/assets/image/icons/KZ.svg"),
    name: "KZ",
    mask: "+7(###) ###-##-##",
    regex: /^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/,
  },
];

const currentMask = ref(defaultFlag.value.mask);
const currentRegex = ref(defaultFlag.value.regex);
const isValidPhone = ref(false);

// Авторизация
const loginUser = async () => {
  const formData = new FormData();
  formData.append("action", "users/login");
  formData.append("method", "POST");
  formData.append("body[username]", inputUsername.value);
  formData.append("body[password]", inputPassword.value);
  formData.append("body[role]", role.value);

  try {
    const response = await axios.post(apiUrl.value, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status) {
      const fullUser = response.data;

      const cookieUser = {
        id: fullUser.id,
        bearer: fullUser.bearer,
      };
      Cookies.set("user", JSON.stringify(cookieUser));

      store.commit("setUser", fullUser);

      emit("goAccount");
    } else {
      alert("Такой пользователь уже существует или не верно введены данные");
    }
  } catch (error) {
    console.error(error);
  }
};

const setRole = () => {
  if (role.value != null) {
    store.commit("setRole", role.value);
  }
  etap.value = 2;
};

const toogleActive = (event) => {
  const items = document.querySelectorAll(".role__itemR");
  const selectedRole = event.currentTarget.dataset.role;
  role.value = selectedRole;

  items.forEach((item) => item.classList.remove("active"));
  event.currentTarget.classList.toggle("active");
};

const flagToogle = () => {
  document.querySelector(".flagList")?.classList.toggle("active");
};

const setFlag = (flag) => {
  document.querySelector(".flagList")?.classList.remove("active");
  defaultFlag.value = flag;
  currentMask.value = flag.mask;
  currentRegex.value = flag.regex;
};

const updatePhoneValidity = (isValid) => {
  isValidPhone.value = isValid;
};

const updatePasswordValidity = (isValid) => {
  console.log("Пароль валиден:", isValid);
};

onMounted(() => {
  etap.value = 1;
});
</script>

<script>
export default {
  directives: {
    validatePass,
    validatePhone,
  },
};
</script>


<template>
  <div class="etaps">
    <div v-if="etap == 1" class="first__etap">
      <div class="head-h2">Выберите роль</div>
      <div class="role__items">
        <div
          @click="toogleActive"
          data-role="specialist"
          class="role__item role__itemR"
        >
          Специалист
        </div>
        <div
          @click="toogleActive"
          data-role="company"
          class="role__item role__itemR"
        >
          Компания
        </div>
        <div
          @click="toogleActive"
          data-role="school"
          class="role__item role__itemR"
        >
          Образование
        </div>
        <div @click="toogleActive2" class="role__item notUse role__itemR">
          HR-агент
        </div>
      </div>
      <div @click="setRole" class="etaps__btn">
        Вперед
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g class="icon" opacity="0.4">
            <path
              d="M11.6797 14.62L14.2397 12.06L11.6797 9.5"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4 12.0596H14.17"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <path
            class="circle"
            d="M12 4C16.42 4 20 7 20 12C20 17 16.42 20 12 20"
            stroke="white"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            class="line"
            d="M20.5 4V20.25"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
    <div v-if="etap == 2" class="second__etap">
      <div class="head-h2">Выполнить вход</div>
      <div class="form">
        <div class="form__item">
          <div class="form__label">Номер телефона</div>
          <MaskInput
            v-validate-phone="{
              regex: currentRegex,
              callback: updatePhoneValidity,
            }"
            v-model="inputUsername"
            class="form__input phone-input"
            :mask="currentMask"
          />
          <div class="flags__wrapper">
            <div class="flags">
              <div @click="flagToogle" class="default">
                <img :src="defaultFlag.icon" alt="" />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                >
                  <path
                    d="M12.45 5.59375L8.37505 9.66875C7.8938 10.15 7.1063 10.15 6.62505 9.66875L2.55005 5.59375"
                    stroke="#1A1A1A"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="flagList">
                <div
                  v-for="flag in allFlags"
                  :key="flag"
                  @click="setFlag(flag)"
                  class="flag_item"
                >
                  <img :src="flag.icon" alt="" />
                  <span>{{ flag.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form__item">
          <div class="form__label">Введите пароль</div>
          <input
            v-validate-pass="updatePasswordValidity"
            v-model="inputPassword"
            class="form__input phone-input"
            :mask="currentMask"
            type="password"
          />
        </div>
      </div>
      <div @click="loginUser" class="etaps__btn">
        Войти
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g class="icon" opacity="0.4">
            <path
              d="M11.6797 14.62L14.2397 12.06L11.6797 9.5"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4 12.0596H14.17"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <path
            class="circle"
            d="M12 4C16.42 4 20 7 20 12C20 17 16.42 20 12 20"
            stroke="white"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            class="line"
            d="M20.5 4V20.25"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>
<style scoped>
</style>